/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard/index'
import { Route as DashboardAccessDeniedRouteImport } from './routes/_dashboard/access-denied'
import { Route as DashboardAccountRouteImport } from './routes/_dashboard/account'
import { Route as DashboardPlansRouteImport } from './routes/_dashboard/plans'
import { Route as DashboardReviewsRouteImport } from './routes/_dashboard/reviews'
import { Route as DeliveryTokenRouteImport } from './routes/delivery/$token'
import { Route as DocumentsTokenRouteImport } from './routes/documents/$token'
import { Route as DashboardAdminOperationsRouteImport } from './routes/_dashboard/admin/operations'
import { Route as DashboardAdminUsersRouteImport } from './routes/_dashboard/admin/users'
import { Route as DashboardDiligencesIndexRouteImport } from './routes/_dashboard/diligences/index'
import { Route as DashboardDiligencesIdRouteImport } from './routes/_dashboard/diligences/$id'

const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAccessDeniedRoute = DashboardAccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAccountRoute = DashboardAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPlansRoute = DashboardPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReviewsRoute = DashboardReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => DashboardRoute,
} as any)
const DeliveryTokenRoute = DeliveryTokenRouteImport.update({
  id: '/delivery/$token',
  path: '/delivery/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsTokenRoute = DocumentsTokenRouteImport.update({
  id: '/documents/$token',
  path: '/documents/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardAdminOperationsRoute =
  DashboardAdminOperationsRouteImport.update({
    id: '/admin/operations',
    path: '/admin/operations',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAdminUsersRoute = DashboardAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDiligencesIndexRoute =
  DashboardDiligencesIndexRouteImport.update({
    id: '/diligences/',
    path: '/diligences/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDiligencesIdRoute = DashboardDiligencesIdRouteImport.update({
  id: '/diligences/$id',
  path: '/diligences/$id',
  getParentRoute: () => DashboardRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof DashboardIndexRoute
  '/login': typeof LoginRoute
  '/access-denied': typeof DashboardAccessDeniedRoute
  '/account': typeof DashboardAccountRoute
  '/plans': typeof DashboardPlansRoute
  '/reviews': typeof DashboardReviewsRoute
  '/delivery/$token': typeof DeliveryTokenRoute
  '/documents/$token': typeof DocumentsTokenRoute
  '/admin/operations': typeof DashboardAdminOperationsRoute
  '/admin/users': typeof DashboardAdminUsersRoute
  '/diligences/$id': typeof DashboardDiligencesIdRoute
  '/diligences/': typeof DashboardDiligencesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/access-denied': typeof DashboardAccessDeniedRoute
  '/account': typeof DashboardAccountRoute
  '/plans': typeof DashboardPlansRoute
  '/reviews': typeof DashboardReviewsRoute
  '/delivery/$token': typeof DeliveryTokenRoute
  '/documents/$token': typeof DocumentsTokenRoute
  '/': typeof DashboardIndexRoute
  '/admin/operations': typeof DashboardAdminOperationsRoute
  '/admin/users': typeof DashboardAdminUsersRoute
  '/diligences/$id': typeof DashboardDiligencesIdRoute
  '/diligences': typeof DashboardDiligencesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/_dashboard/access-denied': typeof DashboardAccessDeniedRoute
  '/_dashboard/account': typeof DashboardAccountRoute
  '/_dashboard/plans': typeof DashboardPlansRoute
  '/_dashboard/reviews': typeof DashboardReviewsRoute
  '/delivery/$token': typeof DeliveryTokenRoute
  '/documents/$token': typeof DocumentsTokenRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/admin/operations': typeof DashboardAdminOperationsRoute
  '/_dashboard/admin/users': typeof DashboardAdminUsersRoute
  '/_dashboard/diligences/$id': typeof DashboardDiligencesIdRoute
  '/_dashboard/diligences/': typeof DashboardDiligencesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/access-denied'
    | '/account'
    | '/plans'
    | '/reviews'
    | '/delivery/$token'
    | '/documents/$token'
    | '/admin/operations'
    | '/admin/users'
    | '/diligences/$id'
    | '/diligences/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/access-denied'
    | '/account'
    | '/plans'
    | '/reviews'
    | '/delivery/$token'
    | '/documents/$token'
    | '/'
    | '/admin/operations'
    | '/admin/users'
    | '/diligences/$id'
    | '/diligences'
  id:
    | '__root__'
    | '/_dashboard'
    | '/login'
    | '/_dashboard/access-denied'
    | '/_dashboard/account'
    | '/_dashboard/plans'
    | '/_dashboard/reviews'
    | '/delivery/$token'
    | '/documents/$token'
    | '/_dashboard/'
    | '/_dashboard/admin/operations'
    | '/_dashboard/admin/users'
    | '/_dashboard/diligences/$id'
    | '/_dashboard/diligences/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
  DeliveryTokenRoute: typeof DeliveryTokenRoute
  DocumentsTokenRoute: typeof DocumentsTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/access-denied': {
      id: '/_dashboard/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof DashboardAccessDeniedRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/account': {
      id: '/_dashboard/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof DashboardAccountRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/plans': {
      id: '/_dashboard/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof DashboardPlansRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/reviews': {
      id: '/_dashboard/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof DashboardReviewsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/delivery/$token': {
      id: '/delivery/$token'
      path: '/delivery/$token'
      fullPath: '/delivery/$token'
      preLoaderRoute: typeof DeliveryTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/$token': {
      id: '/documents/$token'
      path: '/documents/$token'
      fullPath: '/documents/$token'
      preLoaderRoute: typeof DocumentsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/admin/operations': {
      id: '/_dashboard/admin/operations'
      path: '/admin/operations'
      fullPath: '/admin/operations'
      preLoaderRoute: typeof DashboardAdminOperationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/admin/users': {
      id: '/_dashboard/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof DashboardAdminUsersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/diligences/': {
      id: '/_dashboard/diligences/'
      path: '/diligences'
      fullPath: '/diligences/'
      preLoaderRoute: typeof DashboardDiligencesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/diligences/$id': {
      id: '/_dashboard/diligences/$id'
      path: '/diligences/$id'
      fullPath: '/diligences/$id'
      preLoaderRoute: typeof DashboardDiligencesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardAccessDeniedRoute: typeof DashboardAccessDeniedRoute
  DashboardAccountRoute: typeof DashboardAccountRoute
  DashboardPlansRoute: typeof DashboardPlansRoute
  DashboardReviewsRoute: typeof DashboardReviewsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAdminOperationsRoute: typeof DashboardAdminOperationsRoute
  DashboardAdminUsersRoute: typeof DashboardAdminUsersRoute
  DashboardDiligencesIdRoute: typeof DashboardDiligencesIdRoute
  DashboardDiligencesIndexRoute: typeof DashboardDiligencesIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAccessDeniedRoute: DashboardAccessDeniedRoute,
  DashboardAccountRoute: DashboardAccountRoute,
  DashboardPlansRoute: DashboardPlansRoute,
  DashboardReviewsRoute: DashboardReviewsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAdminOperationsRoute: DashboardAdminOperationsRoute,
  DashboardAdminUsersRoute: DashboardAdminUsersRoute,
  DashboardDiligencesIdRoute: DashboardDiligencesIdRoute,
  DashboardDiligencesIndexRoute: DashboardDiligencesIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
  DeliveryTokenRoute: DeliveryTokenRoute,
  DocumentsTokenRoute: DocumentsTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
